/**
 * configs.ts
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 본 프로젝트의 기본 단지코드를 저장합니다.
 * 프로젝트를 복사해서 새 프로젝트를 진행하는 경우 하단의 cdBizLnd 값을 꼭 변경해 주세요.
 * ※ 모듈 공통화 작업으로 단지코드 입력란이 이 곳으로 이동되었습니다.
 * ※ (CAUTION) 이 폴더의 위치나 아래 변수명은 절대 변경하지 마세요. 공통 모듈이 해당 이름으로 참조하고 있습니다.
 *
 * -----------------------------------------------------------------------------------------------
 */

/**
 * @global
 * @description * 단지 코드 정보입니다.
 * cdBizNm : useGaTracker.tsx 공통파일에서 GTM 호출을 위한 변수
 */

export const cdBizLnd = '91XAS7';
export const cdBizNm = 'e편한세상 봉선 셀레스티지'